import { FileTransferInitiator } from "./file-transfer-initiator";

export class CreateAsperaTransferRequest {
  fileIds: number[] = [];
  expireDays: number = 0;
  notes: string | null = null;
  emails: string[] | null = null;
  initiator: FileTransferInitiator | null = null;
  noEmail?: boolean = false;

  constructor(init?: Partial<CreateAsperaTransferRequest>) {
    Object.assign(this, init);
  }
}
